import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getPlanByLicense,
  getTrialLicenseByType,
} from 'Settings/pricing-options';
import {
  getActiveUser,
  getFailedLoginErrorVars,
  getForm,
} from 'Store/reducers';

import Payment from 'Containers/Payment/Payment';
import UserReactivationLoading from 'Containers/Payment/UserReactivationLoading';
import Loading from 'Components/Loading';
import { withRouter } from 'react-router';

import { FORM_ID } from 'Containers/paymentForms/SubscriptionPurchaseForm';

class ExpiredPaymentPage extends React.PureComponent {
  render() {
    const { user, plan, school, form, expiredAdminPassword } = this.props;

    const { isPosting, message } = form || {};
    const isSuccess = !isPosting && message && message.type === 'success';

    if (isSuccess) {
      return (
        <UserReactivationLoading
          authInfo={
            user && {
              username: { value: user.auth_info.username },
              password: {
                value: expiredAdminPassword || user.auth_info.password,
              },
            }
          }
        />
      );
    }

    // if (!user) {
    //   return <Redirect to={ROUTES.SUBSCRIPTION_USERNAME} />;
    // }

    // if (activeUser) {
    //   return <Redirect to={ROUTES.EXPLORE} />;
    // }

    if (!user || !plan || !school) return <Loading />;

    return (
      <Payment
        initialPlan={plan}
        user={user}
        school={school}
        hasExpiredLicense
      />
    );
  }
}

const mapStateToProps = (state, { location }) => {
  const failedLoginErrorVars = getFailedLoginErrorVars(state);
  const expiredAdminPassword = failedLoginErrorVars
    ? failedLoginErrorVars.password
    : undefined;

  const newProps = {
    activeUser: getActiveUser(state),
    form: getForm(state, FORM_ID),
    expiredAdminPassword,
  };

  if (failedLoginErrorVars) {
    const { license, user, school } = failedLoginErrorVars;
    let licenseType;
    if (license) licenseType = license.license_type;
    if (location.state && location.state.licenseType)
      licenseType = getTrialLicenseByType[location.state.licenseType];
    newProps.user = user;
    newProps.plan = getPlanByLicense(licenseType);
    newProps.school = school;
  }
  return newProps;
};

ExpiredPaymentPage.propTypes = {
  user: PropTypes.object,
  plan: PropTypes.object,
  school: PropTypes.object,
  expiredAdminPassword: PropTypes.string,
  form: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(ExpiredPaymentPage));
